/**
 * MiniMiser.WebApi
 * A web API for client access to patient records.   Build date: 2/19/2019 6:49:21 PM
 *
 * OpenAPI spec version: v1.0.02.19
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface GuardianInformationModel { 
    firstName?: string;
    lastName?: string;
    primaryPhoneNumber?: string;
    secondaryPhoneNumber?: string;
    workPhoneNumber?: string;
    /**
     * Permission to leave voicemail
     */
    voiceMailPermission?: boolean;
    hasCustody?: boolean;
    isPrimary?: boolean;
    sameAsClientPhone?: boolean;
    sameAsClientAddress?: boolean;
    sameAsClientEmail?: boolean;
    smsPermission?: boolean;
    smsAppointmentReminder?: boolean;
    address?: string;
    city?: string;
    state?: string;
    zip?: string;
    address2?: string;
    birthdate?: Date;
    gender?: string;
    primaryLanguage?: string;
    placeOfEmployment?: string;
    placeOfEmploymentPhone?: string;
    relationshipToPatient?: string;
    email?: string;    

}
